import React, { useState, useEffect } from "react";
import Breadcrumb from "../Component/Layout/Breadcrumb";
import "../assets/css/ProductDetialsbox.css";
import GalleryImage from "./GalleryImage";
import { Link } from "react-router-dom";
import SearchFilter from "../Component/Layout/SearchFilter";
import SpecifIcation from "../Component/Common/SpecifIcation";
import CartList from "../Component/Checkout/CartList";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProductShorting from "../Component/Common/ProductShorting";
import img001 from '../../src/assets/images/c1.jpg'

function ProductDetails() {
  const productImages = [
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001,
    img001
  ];

  const [selectedImage, setSelectedImage] = useState(productImages[0]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate data fetching delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
      <>
     <Breadcrumb />
        <section className="Product-Detials-box">
          <div className="container">
            <div className="row">
              {/* Left side main image */}
              <div className="col-md-12 col-sm-12 col-12" style={{ borderBottom: "1px solid #e0e0e0", marginBottom: "10px" }}>
              <div className="row">
                  <div className="col-md-6 col-8">
                 {isLoading ? (
                      <Skeleton height={30} />
                    ) : (
                      <SearchFilter />
                    )}
                  </div>
                  <div className="col-md-6 col-4">
                  {isLoading ? (
                      <Skeleton height={30} />
                    ) : (
                      <>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}> 
                    <ProductShorting/>
                        <Link to="/productgraid" className="text-3xl text-gray-500">
                          <i class="bi bi-arrows-move"></i>
                        </Link>
                    </div>
                    </>
                      )}
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                {/* Right side thumbnails */}

                <div className="all-images-box mt-3">
                  <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-2 text-center">
                    {isLoading
                      ? Array.from({ length: 15 }).map((_, index) => (
                          <div className="col" key={index}>
                            <Skeleton height={180} />
                            <Skeleton width={80} height={10} className="mt-1" />
                          </div>
                        ))
                      : productImages.map((img, index) => (
                          <div className="col" key={index}>
                            <div
                              className="boximg"
                              onClick={() => setSelectedImage(img)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedImage === img
                                    ? "1px solidrgb(59, 62, 62)"
                                    : "none",
                                  }}
                                >
                              <img
                                src={img}
                                alt={`product-${index}`}
                                className="img-fluid"
                              />
                               <h2
                              style={{
                                fontSize: "11px",
                                textAlign: "center",
                                marginBottom: "0" ,
                                marginTop: "5px"
                              }}
                            >
                              Carpet001
                            </h2>
                            </div>
                          </div>
                        ))}
                    </div>
                 </div>
               </div>
               <div className="col-md-5">
                  <GalleryImage mainimage={selectedImage} />
                  {/* {isLoading ? (
                      <Skeleton count={1} height={30} width={430} className="mb-2" />
                    ) : (
                      <SpecifIcation />
                    )} */}
              </div>
            </div>

            <div className="row row-cols-1">
               <div className="col-md-12 col-sm-12 col-12">
                      <CartList />
                </div>
                {/* <div className="col-md-5 col-sm-12 col-12">&nbsp;</div>  */}
            </div>



            </div>
        </section>
      </>
    </SkeletonTheme>
  );
}
export default ProductDetails;